import React, { useEffect, useContext } from "react";
import { Navigate } from "react-router";
import { Authentication } from "@swegon/sds-core";

export const SignedOn = () => {
    const { signedOn, isAuthenticated } = useContext(Authentication.AuthContext);
    useEffect(() => {
        if(window.location.hash.length){
            signedOn(window.location.hash);
        }
    });
    return isAuthenticated() ? <Navigate to='/' /> : <div>Signing on...</div>;
};

export default SignedOn;
